var YTIMES = window.YTIMES || {};
$("html").removeClass("no-js");

YTIMES.jsPack = {};
YTIMES.jsPack.cssFiles = [];
YTIMES.jsPack.jsFiles = [];

YTIMES.jsPack.loadEnqueuedFiles = function () {
    YTIMES.jsPack.cssFiles.forEach(function (url) {
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = url;
        document.getElementsByTagName("head")[0].appendChild(link);
    });

    function loadScriptSequentially(urls) {
        if (urls.length !== 0) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.defer = true;
            script.src = urls[0];
            script.onload = function () {
                urls.shift();
                loadScriptSequentially(urls);
            };
            document.getElementsByTagName("head")[0].appendChild(script);
        }
    }
    
    loadScriptSequentially(YTIMES.jsPack.jsFiles.slice());

    $("script-delayed[inline]").each(function () {
        var scriptContent = $(this).html().trim();
        scriptContent = scriptContent.replace(/^<!--/, "")
            .replace(/-->$/, "")
            .replace(/<\/?script[^>]*>/g,"")
            .trim();

        var script = document.createElement("script");
        script.type = "text/javascript";
        script.textContent = scriptContent;
        document.getElementsByTagName("head")[0].appendChild(script);
    });

    $("link-delayed[inline]").each(function () {
        var style = document.createElement("style");
        style.text($(this).text());
        document.getElementsByTagName("head")[0].appendChild(style);
    });
};

YTIMES.jsPack.enqueueCssFile = function (url) {
    YTIMES.jsPack.cssFiles.push(url);
};

YTIMES.jsPack.enqueueJsFile = function (url) {
    YTIMES.jsPack.jsFiles.push(url);
};

YTIMES.jsPack.handleInteraction = function () {
    function interactionHandler() {
        window.clearTimeout(YTIMES.jsPack.interactionTimeout);
        $("body").addClass("interaction");
        window.removeEventListener("scroll", interactionHandler, { passive: true });
        window.removeEventListener("mousewheel", interactionHandler, { passive: true });
        window.removeEventListener("mousemove", interactionHandler, { passive: true });
        window.removeEventListener("click", interactionHandler, { passive: true });
        window.removeEventListener("keydown", interactionHandler, { passive: true });
        window.removeEventListener("touchstart", interactionHandler, { passive: true });
        YTIMES.jsPack.loadEnqueuedFiles();
    }

    window.addEventListener("scroll", interactionHandler, { passive: true });
    window.addEventListener("mousewheel", interactionHandler, { passive: true });
    window.addEventListener("mousemove", interactionHandler, { passive: true });
    window.addEventListener("click", interactionHandler, { passive: true });
    window.addEventListener("keydown", interactionHandler, { passive: true });
    window.addEventListener("touchstart", interactionHandler, { passive: true });
    
    YTIMES.jsPack.interactionTimeout = window.setTimeout(interactionHandler, 6000);
};

$(function () {
    $("script-delayed[src]").each(function () {
        var url = $(this).attr("src");
        YTIMES.jsPack.enqueueJsFile(url);
    });
    $("link-delayed[src]").each(function () {
        var url = $(this).attr("href");
        YTIMES.jsPack.enqueueCssFile(url);
    });
    YTIMES.jsPack.handleInteraction();
});

